import React, {Component} from 'react';
import EtaSharingApp from "./components/EtaSharingApp";

class App extends Component {
    render() {
        return (
            <div className="App">
                <EtaSharingApp/>
            </div>
        );
    }
}

export default App;
